import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PERFIL_COPY } from '../../../data/perfil-microempresario.content';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

/**
 * Modal al salir con sección incompleta (Saltar por ahora / navegación).
 */
@Component({
  selector: 'app-perfil-salir-modal',
  templateUrl: './perfil-salir-modal.component.html',
  styleUrls: ['./perfil-salir-modal.component.scss'],
  standalone: false,
})
export class PerfilSalirModalComponent {
  @Input() open = false;

  @Output() closed = new EventEmitter<void>();
  @Output() guardar = new EventEmitter<void>();

  readonly copy = PERFIL_COPY.modalSalir;

  constructor(private readonly analyticsTag: AnalyticsTagService) {}

  onClose(): void {
    this.closed.emit();
  }

  onGuardar(): void {
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.copy.ctaGuardar,
      ctaSection: 'perfil-salir-modal',
      ctaComponent: 'perfil-salir-modal',
      ctaElementId: 'btn-perfil-salir-guardar',
      hu: '8099',
    });
    this.guardar.emit();
  }

  onBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
